export const firebaseConfig = {
  apiKey: "AIzaSyCCjYQNayh0gfIXuJmfwaND1SMo-AWRmsY",
  authDomain: "type-zz.firebaseapp.com",
  projectId: "type-zz",
  storageBucket: "type-zz.appspot.com",
  messagingSenderId: "1028185919112",
  appId: "1:1028185919112:web:591541da46b919a837993d",
  measurementId: "G-7VQF465MNZ"
};